// Generated by ReScript, PLEASE EDIT WITH CARE

import * as TC from "common/src/components/TC.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Global from "common/src/Global.bs.js";
import * as ItemImage from "common/src/tft-static/ItemImage.bs.js";
import * as UnitImage from "common/src/tft-static/UnitImage.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as ItemTooltip from "common/src/tft-static/ItemTooltip.bs.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as UnitTooltip from "common/src/tft-static/UnitTooltip.bs.js";
import * as Tc2Headliner from "./Tc2Headliner.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import Tab from "@mui/material/Tab";
import * as UnitImageExtended from "common/src/tft-static/UnitImageExtended.bs.js";
import Tabs from "@mui/material/Tabs";
import * as Belt_MutableMapString from "rescript/lib/es6/belt_MutableMapString.js";

function Tc2VariantsTab$Comp(Props) {
  var comp = Props.comp;
  return React.createElement("div", {
              className: "flex gap-2"
            }, Belt_Array.map(comp.units, (function (unitId) {
                    return React.createElement(UnitImageExtended.make, {
                                size: 40,
                                unitId: unitId,
                                items: [],
                                key: unitId
                              });
                  })));
}

var Comp = {
  make: Tc2VariantsTab$Comp
};

function Tc2VariantsTab$Comps(Props) {
  var group = Props.group;
  var headliner = Props.headliner;
  var spatItem = Props.spatItem;
  var comps = Props.comps;
  var totCount = Props.totCount;
  var t = Translation.useT(/* Common */0);
  var coreUnits = TC.extractCore(Belt_Array.map(comps, (function (c) {
              return c.units;
            })));
  var tmp;
  if (spatItem !== undefined) {
    var unitsMap = Belt_MutableMapString.make(undefined);
    Belt_Array.forEach(group.unitItems, (function (ui) {
            if (ui.itemId !== spatItem) {
              return ;
            }
            var curr = Belt_MutableMapString.getWithDefault(unitsMap, ui.unitId, 0);
            return Belt_MutableMapString.set(unitsMap, ui.unitId, curr + ui.count | 0);
          }));
    var unitId = Belt_Option.map(Belt_Array.get(Belt_SortArray.stableSortBy(Belt_MutableMapString.toArray(unitsMap), (function (param, param$1) {
                    return Caml.caml_int_compare(param$1[1], param[1]);
                  })), 0), (function (prim) {
            return prim[0];
          }));
    tmp = React.createElement("div", {
          className: "relative px-[2px] pb-1"
        }, React.createElement(ItemTooltip.make, {
              itemId: spatItem,
              children: React.createElement(ItemImage.make, {
                    itemId: spatItem,
                    size: 40,
                    rounded: "rounded"
                  })
            }), unitId !== undefined ? React.createElement(UnitTooltip.make, {
                unit: unitId,
                children: React.createElement(UnitImage.make, {
                      unitId: unitId,
                      size: 26,
                      className: "absolute bottom-[-6px] left-[10px]"
                    })
              }) : null);
  } else {
    tmp = null;
  }
  var tmp$1;
  if (comps.length === 1) {
    tmp$1 = null;
  } else {
    var space = (Belt_Array.getExn(comps, 0).units.length - coreUnits.length | 0) - 1 | 0;
    tmp$1 = React.createElement(React.Fragment, undefined, React.createElement("div", {
              className: "font-medium font-montserrat text-lg text-center w-[48px] mr-1 pb-[2px]"
            }, t("Flex")), space > 0 ? React.createElement("div", {
                style: Global.s({
                      width: String(Math.imul(space, 42) + ((space - 1 | 0) << 3) | 0) + "px"
                    })
              }) : null);
  }
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "flex flex-col sm:flex-row sm:items-center gap-2"
                }, React.createElement("div", {
                      className: "flex items-center gap-2"
                    }, comps.length === 1 ? null : React.createElement("div", {
                            className: "text-center font-montserrat font-medium text-lg w-[48px]"
                          }, t("Core")), headliner !== undefined ? React.createElement(Tc2Headliner.make, {
                            traitId: headliner
                          }) : null, tmp), React.createElement("div", {
                      className: "flex items-center gap-2"
                    }, Belt_Array.mapWithIndex(coreUnits, (function (idx, unitId) {
                            return React.createElement(UnitImageExtended.make, {
                                        size: 42,
                                        unitId: unitId,
                                        items: [],
                                        key: String(idx)
                                      });
                          })))), React.createElement("div", {
                  className: "flex items-center pt-6 gap-2"
                }, tmp$1, React.createElement("div", {
                      className: "text-center w-[56px]"
                    }, t("Play %")), React.createElement("div", {
                      className: "text-center w-[56px]"
                    }, t("Place")), React.createElement("div", {
                      className: "text-center w-[56px]"
                    }, t("Top 4")), React.createElement("div", {
                      className: "text-center w-[56px]"
                    }, t("Won"))), React.createElement("div", {
                  className: "flex flex-col gap-[16px] pt-[6px]"
                }, Belt_Array.mapWithIndex(comps, (function (idx, comp) {
                        var units = TC.removeCoreUnits(comp.units, coreUnits);
                        return React.createElement("div", {
                                    className: "flex items-center gap-2 font-montserrat font-medium"
                                  }, units.length === 0 ? null : React.createElement("div", {
                                          className: "flex items-center gap-2 px-[2px] mr-1"
                                        }, Belt_Array.mapWithIndex(units, (function (idx, unitId) {
                                                return React.createElement(UnitImageExtended.make, {
                                                            size: 42,
                                                            unitId: unitId,
                                                            items: [],
                                                            key: String(idx)
                                                          });
                                              }))), React.createElement("div", {
                                        className: "text-center w-[56px]"
                                      }, Global.formatPct2(undefined, Global.f(comp.count) / Global.f(totCount))), React.createElement("div", {
                                        className: "text-center w-[56px]"
                                      }, Global.toFixed(undefined, comp.place)), React.createElement("div", {
                                        className: "text-center w-[56px]"
                                      }, Global.formatPct2(undefined, Global.f(comp.top4) / Global.f(comp.count))), React.createElement("div", {
                                        className: "text-center w-[56px]"
                                      }, Global.formatPct2(undefined, Global.f(comp.win) / Global.f(comp.count))));
                      }))));
}

var Comps = {
  make: Tc2VariantsTab$Comps
};

function Tc2VariantsTab$Group(Props) {
  var group = Props.group;
  var comps = Props.comps;
  var totCount = Props.totCount;
  var ets = Belt_MutableMapString.make(undefined);
  Belt_Array.forEachU(comps, (function (comp) {
          var key = Belt_Option.getWithDefault(Belt_Array.get(comp.extraTraits, 0), "") + "|" + Belt_Option.getWithDefault(Belt_Array.get(comp.spatItems, 0), "");
          var curr = Belt_MutableMapString.getWithDefault(ets, key, 0);
          return Belt_MutableMapString.set(ets, key, curr + 1 | 0);
        }));
  var ets$1 = Belt_Array.map(Belt_SortArray.stableSortBy(Belt_MutableMapString.toArray(ets), (function (param, param$1) {
              return Caml.caml_int_compare(param$1[1], param[1]);
            })), (function (prim) {
          return prim[0];
        }));
  return React.createElement("div", {
              className: "flex flex-col"
            }, Belt_Array.mapWithIndex(ets$1, (function (idx, key) {
                    var split = key.split("|");
                    var headliner = Belt_Array.getExn(split, 0);
                    var headliner$1 = headliner === "" ? undefined : headliner;
                    var spatItem = Belt_Array.getExn(split, 1);
                    var spatItem$1 = spatItem === "" ? undefined : spatItem;
                    var comps$1 = Belt_Array.keep(comps, (function (comp) {
                            if (headliner$1 !== undefined ? comp.extraTraits.includes(headliner$1) : comp.extraTraits.length === 0) {
                              if (spatItem$1 !== undefined) {
                                return comp.spatItems.includes(spatItem$1);
                              } else {
                                return comp.spatItems.length === 0;
                              }
                            } else {
                              return false;
                            }
                          }));
                    return React.createElement("div", {
                                className: "py-8 px-6 " + (
                                  idx % 2 === 1 ? "bg-bg2" : ""
                                )
                              }, React.createElement(Tc2VariantsTab$Comps, {
                                    group: group,
                                    headliner: headliner$1,
                                    spatItem: spatItem$1,
                                    comps: comps$1,
                                    totCount: totCount,
                                    key: key
                                  }));
                  })));
}

var Group = {
  make: Tc2VariantsTab$Group
};

function Tc2VariantsTab(Props) {
  var group = Props.group;
  var match = React.useState(function () {
        return /* Lvl8 */0;
      });
  var setTab = match[1];
  var tab = match[0];
  var t = Translation.useT(/* Common */0);
  var tmp;
  switch (tab) {
    case /* Lvl8 */0 :
        tmp = React.createElement(Tc2VariantsTab$Group, {
              group: group,
              comps: group.nonSpatComps,
              totCount: group.count
            });
        break;
    case /* Emblem */1 :
        tmp = React.createElement(Tc2VariantsTab$Group, {
              group: group,
              comps: group.spatComps,
              totCount: group.count
            });
        break;
    case /* Lvl9 */2 :
        tmp = React.createElement(Tc2VariantsTab$Group, {
              group: group,
              comps: group.lvl9Comps,
              totCount: group.count
            });
        break;
    case /* Lvl9Emblem */3 :
        tmp = React.createElement(Tc2VariantsTab$Group, {
              group: group,
              comps: Belt_Option.getWithDefault(group.lvl9SpatComps, []),
              totCount: group.count
            });
        break;
    
  }
  return React.createElement("div", undefined, React.createElement(Tabs, {
                  children: null,
                  value: tab,
                  onChange: (function (param, t) {
                      return Curry._1(setTab, (function (param) {
                                    return t;
                                  }));
                    })
                }, React.createElement(Tab, {
                      label: t("Lvl 8"),
                      value: /* Lvl8 */0
                    }), React.createElement(Tab, {
                      label: t("Emblem"),
                      value: /* Emblem */1
                    }), React.createElement(Tab, {
                      label: t("Lvl 9"),
                      value: /* Lvl9 */2
                    }), React.createElement(Tab, {
                      label: t("Lvl 9") + " + " + t("Emblem"),
                      value: /* Lvl9Emblem */3
                    })), React.createElement("div", {
                  className: "mx-[-20px]"
                }, tmp));
}

var make = Tc2VariantsTab;

export {
  Comp ,
  Comps ,
  Group ,
  make ,
  
}
/* TC Not a pure module */
